import { createSlice } from "@reduxjs/toolkit";
import Cookies from "js-cookie";

const authHandlerFeature = createSlice({
    name: 'auth',
    initialState: {
        data: {},
        token: "",
        isLogin: false
        
    },
    reducers: {
        login: (state, action) => {
            // data store to localstorage and after redirect to homescreen
            // let userData = localStorage.getItem("data");            
            // userData !== null ? JSON.parse(userData) : "";
            state.data = action.payload.data;
            state.token = action.payload.token;
            state.isLogin = true;
        },
        updateProfile: (state, action) => {
            state.data = action.payload.data;
        },
        setLoginStatus: (state, action) => {
            state.isLogin = action.payload;
        },
        logout: (state) => {
            state.data = {};
            state.token = "";
            state.isLogin = false;
            Cookies.remove('token')
        }
    }
});

export const { login, setLoginStatus, logout, updateProfile } = authHandlerFeature.actions;
export default authHandlerFeature.reducer;